module.exports = "<p>\r\n  awsop-lab10 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab10/awsop-lab10.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab10/awsop-lab10.component.html
// module chunks = main